var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionLogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0410156,0,0,0.0410156,11,11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list--1-",
    serifId: "list (1)",
    transform: "matrix(1,0,0,1,-256,-256)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1_17_",
    transform: "matrix(1,0,0,1,5.77495,5.77495)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 160,
    width: 192,
    height: 32,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1_16_",
    transform: "matrix(1,0,0,1,5.77495,9.23992)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 256,
    width: 192,
    height: 32,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 352,
    width: 96,
    height: 32,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.999,32L331.421,32C320.875,13.035 292.107,0 256,0C219.893,0 191.125,13.035 180.578,32L112.001,32C85.532,32 64,53.531 64,80L64,464.001C64,490.47 85.532,512.001 112.001,512.001L400.001,512.001C426.47,512.001 448.001,490.47 448.001,464.001L448.001,80C448,53.531 426.468,32 399.999,32ZM256,32C264.836,32 272,39.162 272,48C272,56.836 264.836,64 256,64C247.164,64 240,56.836 240,48C240,39.162 247.164,32 256,32ZM416,464C416,472.827 408.828,480 399.999,480L112.001,480C103.173,480 96,472.829 96,464L96,80C96,71.173 103.172,64 112.001,64L176.001,64L176.001,80C176.001,88.844 183.157,96 192.001,96L320,96C328.844,96 336,88.844 336,80L336,64L400.001,64C408.828,64 416.001,71.172 416.001,80L416.001,464L416,464Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionLogs);
export default __webpack_public_path__ + "static/media/transaction-logs.a2e47b2abb8b8295faa1ade18e80b344.svg";
export { ForwardRef as ReactComponent };